import React, { useState } from 'react'
import './index.css'

const upsellGiftPriceLookUp = {
  en: 350,
  'en-NZ': 500,
  'en-AU': 400,
  'en-CA': 450,
}

const ProgressBar = ({ total, storeLocale }) => {
  const giftThreshold = upsellGiftPriceLookUp[storeLocale]
  const currencySign = storeLocale === 'en-GB' ? '£' : '$'

  if (!giftThreshold) {
    return null
  }

  return (
    <>
      {total < giftThreshold && (
        <div className="progress-bar">
          <div
            className="filler"
            style={{
              width: `${(total / giftThreshold) * 100}%`,
              maxWidth: '100%',
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              height: '100%',
              textAlign: 'center',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                color: '#5F3E1A',
                textShadow: '-1px 1px 5px rgb(0 0 0 / 20%)',
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              Spend {currencySign}
              {giftThreshold - total} more to get a free gift.
            </span>
          </div>
        </div>
      )}

      {total >= giftThreshold && (
        <div className="progress-bar">
          <div
            className="filler"
            style={{
              width: '100%',
            }}
          />
          <div
            style={{
              position: 'absolute',
              left: 0,
              right: 0,
              top: 0,
              height: '100%',
              textAlign: 'center',
              color: 'white',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <span
              style={{
                color: '#5F3E1A',
                textShadow: '-1px 1px 5px rgb(0 0 0 / 20%)',
                fontSize: 12,
                fontWeight: 600,
              }}
            >
              You have qualified for a free gift!
            </span>
          </div>
        </div>
      )}
    </>
  )
}

export default ProgressBar